import { bindActionCreators } from 'redux';
import React, { useEffect } from 'react';
import SvgSprite from 'components/html-elements/SvgSprite';
import { When } from 'react-if';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import { MESSAGE_TYPE_MESSENGER, MESSAGE_TYPE_MESSENGER_READ } from 'srcJs/components/realtime-notification/constants/constants';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { Link } from 'components/router/Link';
import { REDUCER_CHAT_NOTIFIER_NAME } from 'moduleChatNotifier/constants';
import { reducerChatNotifier } from 'moduleChatNotifier/reducers';
import { chatNotifierLoad } from 'moduleChatNotifier/actions/load';

var Notifier = function Notifier(_ref) {
  var load = _ref.load,
      countNotViewed = _ref.countNotViewed;

  var loadData = function loadData() {
    load();
  };

  var handlerNewMessage = function handlerNewMessage() {
    loadData();
  };

  var handlerRead = function handlerRead() {
    loadData();
  };

  useEffect(function () {
    loadData();
    realtimeNotification.addListener(MESSAGE_TYPE_MESSENGER, handlerNewMessage);
    realtimeNotification.addListener(MESSAGE_TYPE_MESSENGER_READ, handlerRead);
    return function () {
      realtimeNotification.removeListener(handlerNewMessage);
      realtimeNotification.removeListener(handlerRead);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Link, {
    to: "/chat",
    className: "text-decoration-none text-reset d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(SvgSprite, {
    id: "messages",
    size: 16
  }), /*#__PURE__*/React.createElement(When, {
    condition: countNotViewed
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-weight-bold ml-4p lh-narrow"
  }, countNotViewed)));
};

export default connect(Notifier, {
  reducers: {
    name: REDUCER_CHAT_NOTIFIER_NAME,
    reducer: reducerChatNotifier
  },
  mapStateToProps: function mapStateToProps(state) {
    return state[REDUCER_CHAT_NOTIFIER_NAME];
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      load: chatNotifierLoad
    }, dispatch);
  }
});